/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";
import {transactionsDetails} from "./test-data/profile.detail";

const is = require("is_js");

const MODULE_NAME = "MyWalletService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MyWalletService {
    private static instance: MyWalletService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): MyWalletService {
        if (!MyWalletService.instance) {
            MyWalletService.instance = new MyWalletService(props);
        }
        return MyWalletService.instance;
    }

    async verifySignature(signature: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            // if (client) {
            //             const res = await client.query({
            //                 query: GET_ASSET_DETAIL,
            //                 variables: {
            //                     tokenId:assetId,
            //                     storeId:"61739cbd2fbe0a187c984fb6"
            //                 },
            //             });
            // }
            return true;
        } catch (err: any) {
            return err;
        }
    }

    async getMyTransactions(offset?:any, size?:any){
        const _found = transactionsDetails;
        try {
            let _data =
            is.array(_found) &&
            _found.map((item) => {
                return {
                    ...item,
                    scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1",
                };
            });
        // _data = _data.slice(offset, offset + size);

        return {
            pagination: {
                nextOffset: offset + _found.length,
                totalItems: transactionsDetails?.length,
            },
            results: _data,
        };
        }
        catch(err:any){
            return err;
        }

    }
}
